import { message, Modal } from 'antd'

export const logout = (cb: (() => any)) => {
  Modal.confirm({
    prefixCls: 'znd-modal',
    title: '提示',
    content: '确定要退出系统吗？',
    okText: '确定',
    okButtonProps: {
      danger: true,
      style: { background: 'rgba(255,109,109,1)', }
    },
    cancelText: '取消',
    onOk: () => {
      (async () => {
        const login = await cb()
        // if (login._failure) return
        if (login && !login._failure) {
          localStorage.removeItem('loginAreaCodeIndex')
          localStorage.removeItem('loginUserNum')
        }
        message.info('登出系统')
        window.location.href = '#/login'
      })()
    },
  })
}
//  设置/获取cookie
// eslint-disable-next-line consistent-return
export const cookieHelper = (name:string, value = '', option:any = { }):void|string => {
  const options = option
  if (typeof value !== 'undefined') { // name and value given, set cookie
    if (value === null) {
      options.expires = -1
    }
    let expires = ''
    if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
      let date
      if (typeof options.expires === 'number') {
        date = new Date()
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
      } else {
        date = options.expires
      }
      expires = `; expires=${date.toUTCString()}` // use expires attribute, max-age is not supported by IE
    }
    const path = options.path ? `; path=${options.path}` : ''
    const domain = options.domain ? `; domain=${options.domain}` : ''
    const secure = options.secure ? '; secure' : ''
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('')
  } else { // only name given, get cookie
    let cookieValue
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';')
      cookies.forEach((item:string) => {
        if (item) {
          const cookie = item.trim()
          if (cookie.substring(0, name.length + 1) === (`${name}=`)) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
          }
        }
      })
    }
    return cookieValue
  }
}
